import { CONSTANT } from '../../../constant/constant';
import { ENDPOINTS } from '../../../constant/endpoints';
import {
    generalHttpGetRequest,
    generalHttpPostRequest,
    generalHttpPutRequest
} from '../../../helper/request-helper';

const fetchPortfolioUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.portfolio.fetchPortfolio;
const fetchPortfolioFilingsUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.portfolio.fetchPortfolioFilings;
const fetchPortfolioHistoryUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.portfolio.fetchPortfolioHistory;
const fetchPortfoliosByTrustUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.portfolio.fetchPortfolioByTrust;
const addEditNewPortfolioUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.portfolio.addEditNewPortfolio;
const fetchSalesUrl = CONSTANT.baseUrl + ENDPOINTS.employee.sales.fetchSales;
const fetchAdminSalesUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.sales.fetchAdminSales;

export const actionType = {
    REQUESTED_PORTFOLIO_DATA: 'REQUESTED_PORTFOLIO_DATA',
    REJECTED_PORTFOLIO_DATA: 'REJECTED_PORTFOLIO_DATA',
    FETCH_PORTFOLIO_FILINGS: 'FETCH_PORTFOLIO_FILINGS',
    FETCH_PORTFOLIO_HISTORY: 'FETCH_PORTFOLIO_HISTORY',
    FETCH_PORTFOLIO_BY_TRUST: 'FETCH_PORTFOLIO_BY_TRUST',
    EDIT_PORTFOLIO: 'EDIT_PORTFOLIO',
    FETCH_PORTFOLIO: 'FETCH_PORTFOLIO',
    FETCH_PORTFOLIO_BY_ID: 'FETCH_PORTFOLIO_BY_ID',
    ADD_NEW_PORTFOLIO: 'ADD_NEW_PORTFOLIO',
    UPDATE_ADD_NEW_PORTFOLIO_PAYLOAD: 'UPDATE_ADD_NEW_PORTFOLIO_PAYLOAD',
    UPDATE_PORTFOLIO_HISTORY_ITEM_SELECTED:
        'UPDATE_PORTFOLIO_HISTORY_ITEM_SELECTED',
    UPDATE_EDIT_PORTFOLIO_PAYLOAD: 'UPDATE_EDIT_PORTFOLIO_PAYLOAD',
    HANDLE_ADD_PORTFOLIO_VISIBILITY: 'HANDLE_ADD_PORTFOLIO_VISIBILITY',
    HANDLE_EDIT_PORTFOLIO_VISIBILITY: 'HANDLE_EDIT_PORTFOLIO_VISIBILITY',
    HANDLE_VIEW_PORTFOLIO_VISIBILITY: 'HANDLE_VIEW_PORTFOLIO_VISIBILITY',
    FETCH_PORTFOLIO_SALES: 'FETCH_PORTFOLIO_SALES',
    FETCH_PORTFOLIO_ADMIN_SALES: 'FETCH_PORTFOLIO_ADMIN_SALES',
    CLEAR_PORTFOLIOS_LIST: 'CLEAR_PORTFOLIOS_LIST'
};

export const fetchPortfolioData = (portfolioId, parentTrusts) => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_PORTFOLIO_DATA
        });

        return generalHttpGetRequest(fetchPortfolioUrl + portfolioId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PORTFOLIO,
                    payload: response.data,
                    parentTrusts: parentTrusts
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_PORTFOLIO_DATA,
                    data: error
                });
            });
    };
};

export const fetchPortfolioById = portfolioId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_PORTFOLIO_DATA
        });

        return generalHttpGetRequest(fetchPortfolioUrl + portfolioId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PORTFOLIO_BY_ID,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_PORTFOLIO_DATA,
                    data: error
                });
            });
    };
};

export const fetchPortfolioFilings = portfolioId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_PORTFOLIO_DATA
        });

        return generalHttpGetRequest(fetchPortfolioFilingsUrl + portfolioId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PORTFOLIO_FILINGS,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_PORTFOLIO_DATA,
                    data: error
                });
            });
    };
};

export const fetchPortfolioSales = params => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_PORTFOLIO_DATA
        });

        return generalHttpGetRequest(fetchSalesUrl, params)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PORTFOLIO_SALES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_PORTFOLIO_DATA,
                    data: error
                });
            });
    };
};

export const fetchPortfolioAdminSales = params => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_PORTFOLIO_DATA
        });

        return generalHttpGetRequest(fetchAdminSalesUrl, params)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PORTFOLIO_ADMIN_SALES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_PORTFOLIO_DATA,
                    data: error
                });
            });
    };
};

export const fetchPortfolioHistory = portfolioId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_PORTFOLIO_DATA
        });

        return generalHttpGetRequest(fetchPortfolioHistoryUrl + portfolioId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PORTFOLIO_HISTORY,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_PORTFOLIO_DATA,
                    data: error
                });
            });
    };
};

export const fetchPortfolioByTrust = trustId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_PORTFOLIO_DATA
        });

        return generalHttpGetRequest(fetchPortfoliosByTrustUrl + trustId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PORTFOLIO_BY_TRUST,
                    payload: response.data,
                    trustId: trustId
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_PORTFOLIO_DATA,
                    data: error
                });
            });
    };
};

export const addNewPortfolio = payload => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_PORTFOLIO_DATA
        });

        return generalHttpPostRequest(addEditNewPortfolioUrl, payload)
            .then(response => {
                dispatch({
                    type: actionType.ADD_NEW_PORTFOLIO,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_PORTFOLIO_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const editPortfolio = payload => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_PORTFOLIO_DATA
        });

        return generalHttpPutRequest(addEditNewPortfolioUrl, payload)
            .then(response => {
                dispatch({
                    type: actionType.EDIT_PORTFOLIO,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_PORTFOLIO_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const updateAddNewPortfolioPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_ADD_NEW_PORTFOLIO_PAYLOAD,
            payload: selected
        });
    };
};

export const updateEditPortfolioPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_EDIT_PORTFOLIO_PAYLOAD,
            payload: selected
        });
    };
};

export const updatePortfolioHistoryItemSelected = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_PORTFOLIO_HISTORY_ITEM_SELECTED,
            payload: selected
        });
    };
};

export const clearPortfoliosList = () => {
    return dispatch => {
        return dispatch({
            type: actionType.CLEAR_PORTFOLIOS_LIST
        });
    };
};

export const handleAddPortfolioVisibility = visibility => {
    return dispatch => {
        dispatch({
            type: actionType.HANDLE_ADD_PORTFOLIO_VISIBILITY,
            visibility: visibility
        });
    };
};

export const handleEditPortfolioVisibility = visibility => {
    return dispatch => {
        dispatch({
            type: actionType.HANDLE_EDIT_PORTFOLIO_VISIBILITY,
            visibility: visibility
        });
    };
};

export const handleViewPortfolioVisibility = visibility => {
    return dispatch => {
        dispatch({
            type: actionType.HANDLE_VIEW_PORTFOLIO_VISIBILITY,
            visibility: visibility
        });
    };
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/portfolio/actions.js